/* Optional additions only. Keep Dawn's native cart, checkout and line properties intact. */
(()=>{
  document.addEventListener('change',e=>{
    const select=e.target.closest('[data-oc-variant]');if(!select)return;e.stopPropagation();
    const card=select.closest('[data-oc-complement]');card.querySelector('[data-oc-add]').disabled=!select.value;
    const option=select.selectedOptions[0];if(option.dataset.price)card.querySelector('[data-oc-price]').textContent=option.dataset.price;
    if(option.dataset.img){const img=card.querySelector('img');if(img){img.removeAttribute('srcset');img.src=option.dataset.img;}if(option.dataset.href)card.querySelectorAll('a[href]').forEach(a=>{a.href=option.dataset.href;});}
    card.querySelector('[data-oc-status]').textContent='';
  },true);
  document.addEventListener('click',async e=>{
    const button=e.target.closest('[data-oc-add]');if(!button)return;
    const card=button.closest('[data-oc-complement]'),select=card.querySelector('[data-oc-variant]'),status=card.querySelector('[data-oc-status]');
    if(!select.value||button.disabled)return;
    button.disabled=true;select.disabled=true;status.textContent='Ajout en cours…';
    const root=window.Shopify?.routes?.root||'/';
    try{
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(select.value),quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
      const data=await response.json();if(!response.ok||data.status)throw new Error(data.description||'Cet article ne peut pas être ajouté. Réessaie.');
      if(button.getAttribute('role')==='switch')button.setAttribute('aria-checked','true');
      const drawer=document.querySelector('cart-drawer');
      if(drawer&&typeof drawer.renderContents==='function'&&data.sections?.['cart-drawer']){drawer.classList.remove('is-empty');drawer.setActiveElement(document.getElementById('cart-icon-bubble')||button);drawer.renderContents(data);}
      else location.assign(root+'cart');
    }catch(error){if(button.getAttribute('role')==='switch')button.setAttribute('aria-checked','false');status.textContent=error.message||'Ajout impossible pour le moment.';button.disabled=false;select.disabled=false;}
  });

  /* Carrousel des suggestions du panier : défilement continu lent, pause au survol / toucher / focus,
     glissable au doigt, aucun mouvement si prefers-reduced-motion. Les cartes sont dupliquées une fois
     (clones aria-hidden, hors tabulation) pour boucler sans saut. */
  if(!customElements.get('oc-carousel')){
    customElements.define('oc-carousel',class extends HTMLElement{
      connectedCallback(){
        this.track=this.querySelector('[data-oc-track]');
        if(!this.track||this.track.children.length<2)return;
        this.reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused=false;this.hover=false;this.focusIn=false;this.resumeAt=0;this.pos=0;
        if(!this.reduced.matches)this.cloneCards();
        const hold=(ms)=>{this.resumeAt=performance.now()+ms;};
        this.addEventListener('mouseenter',()=>{this.hover=true;});
        this.addEventListener('mouseleave',()=>{this.hover=false;hold(600);});
        this.addEventListener('pointerdown',()=>hold(4000));
        this.addEventListener('touchstart',()=>hold(4000),{passive:true});
        this.addEventListener('wheel',()=>hold(3000),{passive:true});
        this.addEventListener('focusin',()=>{this.focusIn=true;});
        this.addEventListener('focusout',()=>{this.focusIn=this.contains(document.activeElement)&&document.activeElement!==document.body;hold(2500);});
        this.track.addEventListener('scroll',()=>{if(!this.ticking)this.wrap();},{passive:true});
        this.onVisibility=()=>hold(400);document.addEventListener('visibilitychange',this.onVisibility);
        this.last=performance.now();this.frame=requestAnimationFrame(t=>this.step(t));
      }
      disconnectedCallback(){cancelAnimationFrame(this.frame);document.removeEventListener('visibilitychange',this.onVisibility);}
      cloneCards(){
        [...this.track.children].forEach(card=>{
          const clone=card.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.dataset.ocClone='';
          clone.querySelectorAll('a,button,select,input').forEach(el=>el.setAttribute('tabindex','-1'));
          clone.querySelectorAll('[role=status]').forEach(el=>el.removeAttribute('role'));
          this.track.appendChild(clone);
        });
      }
      loopWidth(){const first=this.track.querySelector('[data-oc-clone]');return first?first.offsetLeft-this.track.firstElementChild.offsetLeft:0;}
      wrap(){const w=this.loopWidth();if(w>0&&this.track.scrollLeft>=w){this.track.scrollLeft-=w;this.pos=this.track.scrollLeft;}}
      step(now){
        const dt=Math.min(now-this.last,64);this.last=now;
        const busy=this.reduced.matches||this.hover||this.focusIn||now<this.resumeAt||document.hidden||this.track.querySelector('select:disabled')||!this.offsetParent;
        if(busy){this.pos=this.track.scrollLeft;}
        else{
          this.pos+=dt*0.025;this.ticking=true;this.track.scrollLeft=this.pos;this.wrap();this.ticking=false;
        }
        this.frame=requestAnimationFrame(t=>this.step(t));
      }
    });
  }
})();
